import React from 'react';

const PageBlock = props => <div className="page-block">{props.children}</div>;

export default PageBlock;
